import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { AiOutlineBarChart, AiOutlineLineChart, AiOutlinePieChart, AiOutlineUser } from 'react-icons/ai';
import { BsList } from 'react-icons/bs';

function CAdminDashboard() {
    return (
        <div className='m-0 w-100 main-div'>
            <div
                className="offcanvas offcanvas-top h-100"
                tabIndex="-1"
                id="CollapsedContent"
                aria-labelledby="CollapsedContentLabel"
            >
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="CollapsedContentLabel"></h5>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    ></button>
                </div>
                <div className="offcanvas-body">
                    <ul className="sidebar mt-2">
                        <li>
                            <NavLink to="c-day-wise">
                                <AiOutlinePieChart className='me-2 mb-1' />Daywise Attendance
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="c-last-7-sessions">
                                <AiOutlineBarChart className='me-2 mb-1' />Last 7 Sessions
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="c-overall-attendance">
                                <AiOutlineLineChart className='me-2 mb-1' />Overall Attendance
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="c-deliquents">
                                <AiOutlineUser className='me-2 mb-1' />Deliquents
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="row m-0 p-0">
                <div
                    className="sidebar-bg col-lg-2 col-md-3 navbar-expand-md p-0"
                // style={{ backgroundColor: '#0129517f' }}
                >
                    <div className="">
                        <a
                            data-bs-toggle="offcanvas"
                            className="navbar-toggler toggler"
                            href="#CollapsedContent"
                            role="button"
                            aria-controls="CollapsedContent"
                        >
                            <span className="icon">
                                <BsList />
                            </span>
                        </a>
                        <h6 className='mt-3 pb-1 ps-2'>Attendance</h6>
                        <ul className="sidebar m-0 p-0 d-md-inline d-none list">
                            <li>
                                <NavLink to="c-day-wise">
                                    <AiOutlinePieChart className='me-2 mb-1' />Daywise
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="c-last-7-sessions">
                                    <AiOutlineBarChart className='me-2 mb-1' />Last 7 Sessions
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="c-overall-attendance">
                                    <AiOutlineLineChart className='me-2 mb-1' />Overall
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="c-deliquents">
                                    <AiOutlineUser className='me-2 mb-1' />Deliquents
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="row col-lg-10 col-md-9 m-0 ">
                    <div className="content-data">
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CAdminDashboard;